<template>
  <div id="AboutMeImage3" :class="sectionClass">
    <img src="/static/about-me/i23.webp" />
    <StickMe name="1" size="46" left="16" top="34" uk-parallax="x: 50%" />
    <StickMe name="17" size="26" left="118" top="24" uk-parallax="x: 60%" />
    <StickMe name="17" size="26" left="140" top="5" uk-parallax="x: 25%" />
    <StickMe
      name="71"
      size="100"
      left="64"
      top="35"
      uk-parallax="x: -300%; y: -200%;"
    />
    <StickMe name="3" size="68" left="31" top="13" uk-parallax="x: 100%" />
    <StickMe name="3" size="52" left="-23" top="39" uk-parallax="x: 25%" />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'
import StickMe from './StickMe.vue'

export default {
  components: {
    StickMe,
  },
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  width: 36%;
  padding-top: 50%;
}

.sectionMobile {
  width: 46%;
  padding-top: 45%;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeImage3.vue